import { createSlice } from "@reduxjs/toolkit";

const ipSlice = createSlice({
  name: "ip",
  initialState: {
    loading: false,
    error: null,
    ipRestrictions: [],
    totalCount: {},
  },
  reducers: {
    getIpRestrictionsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getIpRestrictionsSuccess(state, action) {
      state.loading = false;
      // Handle standard paginated response structure
      state.ipRestrictions = action.payload.data || action.payload || [];
      state.totalCount = action.payload.totalCount || {};
    },
    getIpRestrictionsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getIpRestrictionsStart,
  getIpRestrictionsSuccess,
  getIpRestrictionsFailure,
} = ipSlice.actions;

export default ipSlice.reducer;
